import { useRef, useState } from "react";
import { trans } from "../utils";
import {  toast } from 'react-toastify';
import axios from "axios";
import { SystemUrl } from "../../App";
import { read, utils } from 'xlsx';




const UploadExcelModal = ({data,GetModuleData}) => {

    const [modal, setModal] = useState(false)

    const $ = require("jquery");

    const [form, setForm] = useState({
        isValid: false, // Set the initial validity state to false
      });
    
    const [file, setFile] = useState(null);

    const [isDisabled, setDisabled] = useState(false);

    const UploadExcel = () => {
        setDisabled(true);
        let formData = new FormData();
        formData.append("file", file);
        const reader = new FileReader();
        reader.onload = (event) => {
            let rowOverCount = false;
            let sheetOverCount = false;
            const buffer = event.target.result;
            const workbook = read(buffer, { type: 'array' });
            if (workbook.SheetNames.length > 1) {
                sheetOverCount = true;
            }
            if (sheetOverCount) {
                setDisabled(false);
                toast.error('The workbook contains more than one sheet. Please upload a workbook with only one sheet.');
                return;
            }
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const range = utils.decode_range(sheet['!ref']);
            const rowCount = range.e.r - range.s.r + 1;        
            if (rowCount > 2500) {
            rowOverCount = true;
            }
            if (rowOverCount) {
                setDisabled(false);
                toast.error('Maximum number of rows is 2500');
                return;
            }
            axios.post(SystemUrl + data.getmodule + '/import', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }).then(res => {
                $("#datatable").DataTable().ajax.reload();
                toast.success(trans('Success'));
                setDisabled(false);
        
                // Clear the input field
                inputFileRef.current.value = '';
                setModal(false)
                // Close the modal
                const modal = document.getElementById('AssignModal')
                if (modal) {
                    modal.classList.remove('show')
                    modal.style.display = 'none'
                    const modalBackdrop = document.getElementsByClassName('modal-backdrop')[0]
                    if (modalBackdrop) {
                        modalBackdrop.parentNode?.removeChild(modalBackdrop)
                    }
                }
            }).catch((err) => {
                setDisabled(false);
                setModal(true)
                var error = "";
                err.response.data.message.forEach(el => {
                    error += (el + "\n\r\t");
                });
                toast.error(error, { position: toast.POSITION.UPPER_RIGHT });
            });
        };
        reader.readAsArrayBuffer(file);
    }
    const inputFileRef = useRef(null);
    return (

        <div className="modal fade" id="AssignModal" tabIndex="-1" role="dialog"
        aria-labelledby="AssignModalLabel" aria-hidden="true">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">{trans('Upload')} {trans(GetModuleData.name_en)} <a href={SystemUrl + data.getmodule + '?export=1'} download>{trans('Download Sample')}</a></h5>
                        <button type="button" className="close" data-dismiss="modal"
                                aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form>

                            <div className="form-group">
                                <label htmlFor="message-text"
                                        className="col-form-label">{trans('Actions options')} :</label>
                                <input ref={inputFileRef} onChange={e => setFile(e.target.files[0])} type="file" className="form-control" required />
                            </div>
                            <div className="modal-footer">
                                <div className="row">

                                    <div className="col-md-6">
                                        <button type="button" className="btn btn-secondary"
                                                data-dismiss="modal">{trans('Close')}
                                        </button>
                                    </div>
                                    <div className="col-md-6">
                                        <button type="button" onClick={UploadExcel} className="btn btn-primary" disabled={isDisabled}
                                                                    data-bs-dismiss={form.isValid ? (modal ? 'modal' : '') : ''}
                                                                >{trans('Submit')}</button>

                                    </div>


                                </div>

                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UploadExcelModal